import React from 'react';
import { ReactComponent as ChartType } from '../../assets/images/icons/chartType.svg';

export default function ChartTypeIcon({ className }) {
  return (
    <ChartType className={`icon ${className}`} />
  );
}
